import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/src/doi-tac-module/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/src/doi-tac-module/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationProvider"] */ "/vercel/path0/src/doi-tac-module/contexts/NavigationContext.tsx");
